import { Gemeente } from '../types';
import { Get } from './helpers/builder';

export const getAllGemente = Get`/gemeente/all`.json<{response: Gemeente[]}>();
